import React, { createContext, useContext, useState } from 'react';
import NotificationToast from '../components/elements/NotificationToast';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  // Function to add a notification
  const addNotification = (type, message) => {
    setNotifications((prev) => [
      ...prev.filter((notification) => notification.message !== message),
      { id: Date.now(), type, message },
    ]);
  };

  // Function to remove a notification
  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((notification) => notification.id !== id));
  };

  return (
    <NotificationContext.Provider value={{ addNotification }}>
      {children}
      {notifications.map(({ id, type, message }) => (
        <NotificationToast
          key={id}
          id={id}
          type={type}
          message={message}
          onClose={removeNotification}
        />
      ))}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
